import {
  FaPlus,
  FaRegFile,
  FaRegCopy,
  FaRegChartBar,
  FaChevronLeft,
  FaTasks,
  FaRegListAlt,
  FaRegCalendarAlt,
  FaHammer,
  FaSuitcase,
} from 'react-icons/fa';
import { HiOutlineUserGroup } from 'react-icons/hi';

const operatorClientMenuItems = [
  {
    label: 'Създаване на документ',
    icon: FaPlus,
    to: '/documents-wizard/step-1',
    type: 'button',
  },
  {
    label: 'Настройки',
    ariaLabel: 'Menu settings',
    icon: FaRegCopy,
    to: '/settings',
    childrenRoutes: [
      {
        label: 'Шаблони',
        icon: FaRegCopy,
        to: '/document-templates',
      },
      {
        label: 'Полета',
        icon: FaRegListAlt,
        to: '/fields',
      },
      {
        label: 'Сегменти',
        icon: FaTasks,
        to: '/segments',
      },
    ],
  },
  {
    label: 'Документи',
    icon: FaRegFile,
    to: '/documents/received',
  },
  {
    label: 'Структура',
    icon: HiOutlineUserGroup,
    to: '/structure/groups',
  },
  {
    label: 'Справки',
    icon: FaRegChartBar,
    to: '/reports/documents',
  },
  {
    label: 'Отпуски',
    icon: FaRegCalendarAlt,
    to: '/leaves',
  },
  {
    label: 'Почасови отсъствия',
    icon: FaRegCalendarAlt,
    to: '/hourly-absences',
  },
  {
    label: 'ЗБУТ',
    icon: FaHammer,
    to: '/health-and-safety-training',
  },
  {
    label: 'Командировки',
    icon: FaSuitcase,
    to: '/work-trips',
  },
  {
    label: 'Изход от клиент',
    icon: FaChevronLeft,
    to: '',
    type: 'exit-client',
  },
];

export default operatorClientMenuItems;
